import { isValidElement } from 'react';
import { flattenClassNames } from '@trukt/portal-utils/flattenClassNames';
import { Typography } from '../Typography';
import { TagProps } from './Tag.types';

export const Tag = ({
  label,
  subLabel,
  className,
  backgroundColor = 'bg-primary-400',
}: TagProps) => {
  return (
    <div
      className={flattenClassNames([
        'flex h-[61px] w-36 flex-col gap-1 rounded-b-md p-3 shadow-basic',
        backgroundColor,
        className,
      ])}
    >
      {isValidElement(label) ? (
        label
      ) : (
        <Typography variant="h4" className="font-900 !text-common-white capitalize">
          {label}
        </Typography>
      )}

      {subLabel && <Typography className="!text-common-white capitalize">{subLabel}</Typography>}
    </div>
  );
};
